<div class="form-parent" *ngIf="loadMessageTemplate">
    <kgrid 
    [apiName]="apiName"
    [noAutoFitColumns]="true" 
    [label]="label"
    [dataList]="dataList"
    [areaName]="areaName"
    [name]="apiName"
    [useCustomDelete]="true"
    [isMulti]="true"
    (onDelete)="deleteHandler($event)"
    [inputEditorform]="inputEditorform">
</kgrid>
</div>